// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"styles_textareaWrapper__2ZK2y","textarea":"styles_textarea__3SUMj","textareaError":"styles_textareaError__1Z_h8","errorText":"styles_errorText__1F1Wk"};